import classNames from "classnames";
import { TiLocation } from "react-icons/ti";

// interfaces
import { TSpaceAssetType } from "@/types/Global";

// assets
import styles from "@/assets/styles/pages/location-single-page/location-single-page-components.module.scss";


export interface IFloorPlanMark {
  coordinates: {
    x: number;
    y: number;
  };
  parentWidth: number;
  onPinClick?: () => void;
  spaceAssetType: TSpaceAssetType;
}

const COORDINATES_FLOOR_WIDTH = 690;
const COORDINATES_SHIFT_VALUE_LEFT = 18;
const COORDINATES_SHIFT_VALUE_TOP = 32;

function FloorPlanMark(props: IFloorPlanMark) {
  const { coordinates, parentWidth, spaceAssetType, onPinClick } = props;

  const top = coordinates && parentWidth ? `${((coordinates.y * parentWidth) / COORDINATES_FLOOR_WIDTH) - COORDINATES_SHIFT_VALUE_TOP}px` : "0px";
  const left = coordinates && parentWidth ? `${((coordinates.x * parentWidth) / COORDINATES_FLOOR_WIDTH) - COORDINATES_SHIFT_VALUE_LEFT}px` : "0px";

  return (
    <div
      className={classNames(
        styles["locl-location-floor-plan__mark"],
        { [styles["locl-location-floor-plan__mark_media"]]: spaceAssetType === "media_opportunity" }
      )}
      style={{ top, left }}
      onClick={() => onPinClick ? onPinClick() : null}
      data-testid="locl-location-floor-plan-mark"
    >
      <span className={styles["locl-location-floor-plan__mark__icon"]} data-testid="locl-location-floor-plan-mark-icon">
        <TiLocation/>
      </span>
    </div>
  );
}

export default FloorPlanMark;
